<ul class="product-tags">
  <!-- section title -->
  <li class="product-tags__title">
    {{ 'products.tags' | translate }}
  </li>
  <!-- tags -->
  @for (tag of tagsData(); track tag) {
    <li class="product-tags__item"># {{ tag }}</li>
  }
</ul>
